import React, { memo } from "react";
import { useDisclosure } from '@chakra-ui/react'
import { MenuEditModalLayout } from "./MenuEditModalLayout";
import { useEditKoreanMenuImage } from "../../../hooks/menu/useEditKoreanMenuImage";

type MenuEditModalProps = {
  id: string;
  mutateKey: string;
}
export const KoreanMenuEditModal: React.FC<MenuEditModalProps> = memo(({id, mutateKey}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const onSubmit = useEditKoreanMenuImage(id, mutateKey, onClose)
  return (
    <MenuEditModalLayout
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
});